import { notFound } from 'next/navigation';

import type { ISlotItemDate } from '@/entities/slot/types';
import { NEXT_PUBLIC_API_URL } from '@/lib/env';
import { utilFetch } from '@/lib/utils';

const apiGetSlotDateList = async (idx: string): Promise<ISlotItemDate[]> => {
  const response = await utilFetch()(`${NEXT_PUBLIC_API_URL}/api/slot/date/${idx}`, {
    method: 'GET',
  });
  const result = await response.json();

  // error handling
  if (!result.ok) {
    notFound();
  }

  return result.data;
};

export default apiGetSlotDateList;
